/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { legacySharedTreeInitialTreeId } from './id-compressor';
/**
 * The initial tree.
 * @public
 */
export const initialTree = {
    traits: {},
    definition: '51c58718-47b9-4fe4-ad46-56312f3b9e86',
    identifier: legacySharedTreeInitialTreeId,
};
//# sourceMappingURL=InitialTree.js.map